import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('loading');

    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('website_alt');
    if (honeypot && String(honeypot).trim() !== '') {
      setStatus('success');
      setMessage('订阅成功！感谢你的关注。');
      setEmail('');
      return;
    }

    const payload = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key !== 'website_alt') {
        payload.append(key, String(value));
      }
    });

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });

      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！每周精选夜间内容将发送到你的邮箱。');
        setEmail('');
      } else {
        setStatus('error');
        setMessage(parsed?.meta?.message || parsed?.message || '订阅失败，请稍后重试');
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请稍后重试');
    }
  };

  return (
    <section className="py-16 md:py-24 bg-background-950">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-500/10 border border-accent-500/20 text-accent-400 text-sm mb-6">
          <i className="ri-mail-line"></i>
          <span>夜无疆通讯</span>
        </span>
        <h2 className="font-heading text-3xl md:text-4xl text-foreground-100 mb-4">
          加入夜行者社群
        </h2>
        <p className="text-foreground-500 text-base max-w-lg mx-auto mb-8 leading-relaxed">
          每周精选夜间故事、创作灵感和社群活动，直接发送到你的邮箱。和千万夜行者一起，探索夜晚的无限可能。
        </p>

        {status === 'success' ? (
          <div className="bg-primary-500/10 border border-primary-500/20 rounded-xl p-6">
            <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-500/20">
              <i className="ri-check-line text-primary-400 text-2xl"></i>
            </div>
            <p className="text-primary-400 font-medium">{message}</p>
          </div>
        ) : (
          <form
            data-readdy-form
            id="hero-newsletter"
            action="https://readdy.ai/api/form/d9u074n8l97n3eas3erg"
            method="POST"
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          >
            <div className="website-field-wrap">
              <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
            </div>
            <input
              type="email"
              name="email"
              placeholder="输入你的邮箱地址"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-1 px-5 py-3 bg-background-800 border border-background-700 rounded-lg text-sm text-foreground-200 placeholder-foreground-600 focus:outline-none focus:border-primary-500/50 transition-all duration-200"
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="px-6 py-3 bg-primary-500 hover:bg-primary-600 disabled:opacity-60 text-background-950 font-medium text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              {status === 'loading' ? '订阅中...' : '立即订阅'}
            </button>
            {status === 'error' && (
              <p className="text-red-400 text-sm mt-2 w-full">{message}</p>
            )}
          </form>
        )}

        <p className="text-foreground-600 text-xs mt-4">
          我们尊重你的隐私，绝不发送垃圾邮件。可随时退订。
        </p>
      </div>
    </section>
  );
}